// MerchantLanding.js
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';


const MerchantLanding = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/merchant-login'); // always go to login
  }, [navigate]);

  return null; // No UI needed, only redirection
};

export default MerchantLanding;
